/**
 * Flag — a country flag as an image, not an emoji.
 *
 * Regional-indicator emoji (🇬🇧) render as bare letters on Windows, which is
 * most of this product's traffic, so /scan has always fetched raster flags
 * from flagcdn.com. This is that component, lifted out of the scan page so
 * the sign-up country picker shows the same flags rather than a second
 * implementation that drifts.
 *
 * `code` is a lowercase ISO 3166-1 alpha-2 code — flagcdn's own key.
 */
export function Flag({ code, size = 18 }: { code: string; size?: number }) {
  const h = size;
  const w = Math.round((size * 4) / 3);
  // flagcdn publishes fixed widths; pick the nearest one up.
  const wPx = h <= 14 ? 20 : h <= 22 ? 40 : 80;
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      alt=""
      className="scan-flag"
      decoding="async"
      height={h}
      loading="lazy"
      src={`https://flagcdn.com/w${wPx}/${code}.png`}
      srcSet={`https://flagcdn.com/w${wPx * 2}/${code}.png 2x`}
      width={w}
    />
  );
}

export default Flag;
